export const FETCH_FORM_TEMPLATES_SUCCESS = 'FETCH_FORM_TEMPLATES_SUCCESS';
export const SET_FORM_TEMPLATES_ERROR = 'SET_FORM_TEMPLATES_ERROR';
export const SET_FORM_TEMPLATE_ALL_IDS = 'SET_FORM_TEMPLATE_ALL_IDS';
export const SET_FORM_TEMPLATE_FETCH_REQUEST_LOADING = 'SET_FORM_TEMPLATE_FETCH_REQUEST_LOADING';
export const SET_FORM_TEMPLATE = 'SET_FORM_TEMPLATE';
export const SET_FORM_TEMPLATE_VERSION = 'SET_FORM_TEMPLATE_VERSION';
export const ADD_A_NEW_FIELD = 'ADD_A_NEW_FIELD';
export const SET_FIELD_VALUE = 'SET_FIELD_VALUE';
export const RESET_FIELD = 'RESET_FIELD';
export const SET_ACTIVE_ACCORDION = 'SET_ACTIVE_ACCORDION';
export const SET_INACTIVE_ACCORDION = 'SET_INACTIVE_ACCORDION';
export const SET_TEMPLATE_VALUE = 'SET_TEMPLATE_VALUE';
export const SET_REARRANGE_POSITION = 'SET_REARRANGE_POSITION';
export const CREATE_FORM_TEMPLATE = 'CREATE_FORM_TEMPLATE';
export const UPDATE_FORM_TEMPLATE_REQUEST = 'UPDATE_FORM_TEMPLATE_REQUEST';
export const FETCH_TRIAL_CONTAINERS_SUCCESS = 'FETCH_TRIAL_CONTAINERS_SUCCESS';
export const FETCH_TRIAL_CONTAINERS_FAILURE = 'FETCH_TRIAL_CONTAINERS_FAILURE';
export const SET_TRIAL_CONTAINER_ALL_IDS = 'SET_TRIAL_CONTAINER_ALL_IDS';
export const SET_TRIAL_CONTAINER_FETCH_REQUEST_LOADING = 'SET_TRIAL_CONTAINER_FETCH_REQUEST_LOADING';
export const REMOVE_FIELD = 'REMOVE_FIELD';
export const SET_READ_ONLY = 'SET_READ_ONLY';
export const SET_FIELD_OTHER_ENABLED = 'SET_FIELD_OTHER_ENABLED';
export const SET_OTHER_FIELD_LABEL = 'SET_OTHER_FIELD_LABEL';
export const FETCH_WORKFLOW_DEFINITIONS_SUCCESS = 'FETCH_WORKFLOW_DEFINITIONS_SUCCESS';
export const FETCH_WORKFLOW_DEFINITIONS_FAILURE = 'FETCH_WORKFLOW_DEFINITIONS_FAILURE';
export const SET_WORKFLOW_DEFINITIONS_FETCH_REQUEST_LOADING = 'SET_WORKFLOW_DEFINITIONS_FETCH_REQUEST_LOADING';
export const SET_WORKFLOW_DEFINITIONS = 'SET_WORKFLOW_DEFINITIONS';
